"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _config = require("../../../config/config");

var Opaque = function Opaque(_ref) {
  var opaque = _ref.opaque,
      handleChange = _ref.handleChange;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      controlId: "OpacityControl",
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: "d-flex"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Check, {
      type: "checkbox",
      name: "opaque",
      "data-cy": "text-opaque-checkbox",
      checked: !!opaque,
      onChange: handleChange,
      style: {
        fontWeight: 300,
        fontSize: 14
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        fontWeight: 300,
        fontSize: 14
      }
    }, "Opaque",
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Text, {
      className: "text-muted m-0 p-0"
    }, "Add a white background to the filled field so the final PDF has the text overlayed a white background."))))
  );
};

Opaque.defaultProps = {
  opaque: false
};
Opaque.propTypes = process.env.NODE_ENV !== "production" ? {
  opaque: _propTypes["default"].bool,
  handleChange: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = Opaque;